module.exports = __webpack_public_path__ + "static/media/29FUNOV16.e7c09d96.jpg";